<template>
  <div class="getapi">
    <el-container>
      <el-header style="height: 100px">
        <Head></Head>
      </el-header>
      <el-main class="getapi_body">
        <el-row>
          <el-col :span="4" class="sidebar">
            <el-menu :default-active="active" class="el-menu-vertical-demo">
              <el-submenu index="1">
                <template #title>
                  <div class="title_img">
                    <img
                      src="http://apiupss.ppfly.top/images/by1.svg"
                      alt=""
                    />
                    API提取
                  </div>
                </template>
                <el-menu-item @click="onclick('api提取')" index="1-1"
                  >API提取</el-menu-item
                >
                <el-menu-item @click="onclick('API教程demo')" index="1-2"
                  >API教程demo</el-menu-item
                >
              </el-submenu>
              <el-submenu index="2">
                <template #title>
                  <div class="title_img">
                    <img
                      src="http://apiupss.ppfly.top/images/by2.svg"
                      alt=""
                    />账号认证获取
                  </div>
                </template>
                <el-menu-item @click="onclick('账密认证获取')" index="2-1"
                  >账户认证获取</el-menu-item
                >
                <el-menu-item @click="onclick('账密认证Demo')" index="2-2"
                  >账密教程Demo</el-menu-item
                >
              </el-submenu>
              <el-submenu index="3">
                <template #title>
                  <div class="title_img">
                    <img
                      src="http://apiupss.ppfly.top/images/by3.svg"
                      alt=""
                    />代理管理器
                  </div>
                </template>
                <el-menu-item @click="onclick('代理管理器')" index="3-1"
                  >代理管理器</el-menu-item
                >
              </el-submenu>
            </el-menu>
          </el-col>

          <el-col :span="20" class="main-content">
            <div v-show="lei_apitiqu == 'api提取'">
              <Apiget_ponents></Apiget_ponents>
            </div>
            <div v-show="lei_apitiqu == 'API教程demo'">
              <apiget_apijcdome></apiget_apijcdome>
            </div>
            <div v-show="lei_apitiqu == '账密认证获取'">
              <apigetzhrzhq></apigetzhrzhq>
            </div>
            <div v-show="lei_apitiqu == '账密认证Demo'">
              <apiget_apizmjcdome></apiget_apizmjcdome>
            </div>
            <div v-show="lei_apitiqu == '代理管理器'">
              <apiget_dlglq></apiget_dlglq>
            </div>
          </el-col>
        </el-row>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import Head from "@/components/head/head.vue";
import Apiget_ponents from "@/components/apiget_ponents/apiget_ponents.vue";
import apiget_apijcdome from "@/components/apiget_apijcdome/apiget_apijcdome.vue";
import apigetzhrzhq from "@/components/apigetzhrzhq/apigetzhrzhq.vue";
import apiget_apizmjcdome from "@/components/apiget_apizmjcdome/apiget_apizmjcdome.vue";
import apiget_dlglq from "@/components/apiget_dlglq/apiget_dlglq.vue";
export default {
  data() {
    return {
      active: "1-1",
      lei_apitiqu: "api提取",
      shifoudiqu: false,
      maindiv: "",
      isActive: false,
      isActiveB: false,
      form: {
        package: "",
        quantity: "",
        dataFormat: "",
        country: "",
        proxyAgreement: "",
        separator: "",
      },
    };
  },
  components: {
    Head,
    Apiget_ponents,
    apiget_apijcdome,
    apigetzhrzhq,
    apiget_apizmjcdome,
    apiget_dlglq,
  },
  created() {
    // 在组件创建时获取路由参数
    // this.userId = this.$route.params.id;
    if (this.$route.query.name) {
      this.lei_apitiqu = this.$route.query.name;
      console.log("sssss");
      if (this.lei_apitiqu == "API教程demo") {
        this.active = "1-2";
      } else if (this.lei_apitiqu == "API教程demo") {
        this.active = "1-2";
      } else if (this.lei_apitiqu == "账密认证获取") {
        this.active = "2-1";
      } else if (this.lei_apitiqu == "账密认证Demo") {
        this.active = "2-2";
      } else if (this.lei_apitiqu == "代理管理器") {
        this.active = "3-1";
      }
    }
    console.log(this.lei_apitiqu);
    console.log("created");
  },
  onload() {
    console.log(this.lei_apitiqu);
    console.log("onload");
  },
  mounted() {},
  methods: {
    onclick(name) {
      this.lei_apitiqu = name;
      console.log(name);
    },
    toggleBorder() {
      this.isActive = true; // 切换边框状态
      this.isActiveB = false;
    },
    toggleBorderB() {
      this.isActiveB = true; // 切换边框状态
      this.isActive = false;
    },
    generateLink() {
      // 处理生成链接的逻辑
      console.log("生成链接:", this.form);
    },
  },
};
</script>
<style>
.getapi {
}

.getapi_body {
}

.sidebar_ret {
  background-color: #edf3fc;
  /* 左侧导航栏背景色 */
  padding: 20px;
  /* 内边距 */
  position: absolute;
  left: 1280px;
}

.main-content {
  padding: 20px;
  /* 右侧主体内容内边距 */
}

.el-menu-item {
  border-radius: 15px;
  text-align: left;
}

.title_img {
  text-align: left;
}

/* 鼠标悬浮时二级菜单的样式 */

.main-content_pane_div {
  display: flex;
  justify-content: space-between;
}

.content_pane_div_let_div {
  overflow-y: scroll;
  height: 730px;
}
.content_pane_div_let_div_div {
  display: flex;
  justify-content: space-around;
  width: 900px;
  padding: 10px;
}

.content_pane_div_let_div_divs {
  display: flex;
  justify-content: space-between;
  padding: 30px;
  border-radius: 5px;
  width: 400px;
}

.content_pane_div_let_div_divsB {
  display: flex;
  justify-content: space-between;
  padding: 30px;
  border-radius: 5px;
  width: 1400px;
}

.active-border {
  box-shadow: rgba(3, 102, 214, 0.3) 0px 0px 0px 3px;
  /* 点击后添加的边框样式 */
}

.content_pane_div_let_div_divs:nth-child(1) {
  margin-right: 10px;
}

.content_pane_div_let_div_divs > div:nth-child(1) {
}

.content_pane_div_let_div_divs > div:nth-child(2) {
}

.content_pane_div_let_div_divs > div:nth-child(3) {
}

.zhed_cls {
  text-align: left;
  display: flex;
  align-items: center;
  font-family: SourceHanSansCN-Regular;
  font-size: 16px;
  color: #18181b;
}

.div_zhed_cls_text {
  margin-top: 10px;
}

.zhed_cls_text {
  font-size: 14px;
  color: #737791;
  display: flex;
  justify-content: space-between;
}

.zhed_cls_text > div {
  font-size: 16px;
  color: #000;
  line-height: 22px;
}

.main-content {
  padding: 20px;
  /* 右侧主体内容内边距 */
}

.div_xiala {
  background-color: #edf3fc;
  /* 表单背景色 */
  padding: 20px;
  /* 内边距 */
  border-radius: 5px;
  /* 圆角 */
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  /* 阴影效果 */
}

.sidebar {
  background-color: #edf3fc;
  /* 左侧导航栏背景色 */
  padding: 20px;
  /* 内边距 */
}

.main-content {
  padding: 20px;
  /* 右侧主体内容内边距 */
}

.jkcszj {
  background-color: #edf3fc;
  /* 接口参数注解背景色 */
  padding: 20px;
  /* 内边距 */
  border-radius: 5px;
  /* 圆角 */
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  /* 阴影效果 */
}

.jkcszj h2 {
  margin-bottom: 20px;
  /* 标题下边距 */
}

.no-border-table {
  width: 100%;
  border-collapse: collapse;
  /* 合并边框 */
}

.no-border-table th,
.no-border-table td {
  border: none;
  /* 无边框 */
  padding: 10px;
  /* 单元格内边距 */
  text-align: left;
  /* 左对齐 */
}

.no-border-table th {
  background-color: #f0f0f0;
  /* 表头背景色 */
}

.H2_text {
  font-family: SourceHanSansCN-Bold;
  font-size: 16px;
  color: #18181b;
  display: flex;
  align-items: center;
  margin-left: -25px;
}

.H3_text {
  font-family: SourceHanSansCN-Bold;
  font-size: 13px;
  color: #505053;
  display: flex;
  align-items: center;
}

.top_name {
  font-size: 16px;
  font-weight: 700;
  background: #f0f9ff;
  border-radius: 7px;
  height: 48px;
  border-bottom: none;
}

.top_name_th {
  font-size: 13px;
}

.top_text {
  font-size: 14px;
  height: 40px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.04);
  font-size: 14px;
  font-weight: 400;
  color: #444a6d;
  text-align: center;
}

.json-code {
  text-align: left;
  /* 使文本左对齐 */
  background-color: #f8f8f8;
  /* 设置背景颜色 */
  /* 添加边框 */
  padding: 10px;
  /* 添加内边距 */
  overflow: auto;
  /* 处理溢出内容 */
  white-space: pre-wrap;
  /* 允许换行 */
  font-family: SimHei;
  /* 使用等宽字体 */
  font-size: 15px;
}

.lan_ {
  color: #569fcf;
}

.hong_ {
  color: #be470f;
}
</style>